<script setup lang="ts">
import { type Components } from '@workbench/core';
import { WbEcoRating } from '@dh-io-owpi/shared/src/components/ssr/wb';
import { useAemData } from '@/composables/useAemData';
import { type TechDataTableCellProps } from './utils';

const props = defineProps<TechDataTableCellProps<object>>();
const aemData = useAemData();

const locale = `${aemData.language}_${aemData.country}` as Components.WbEcoRating['locale'];
</script>
<template>
  <WbEcoRating v-bind="props.value.value" :locale data-allow-mismatch class="owpi-tech-data-table__cell-eco" />
</template>
<style lang="scss">
.owpi-tech-data-table__cell-eco {
  --_er-width: 67px;
  --_er-aspect-ratio: 1 / 1;

  margin-inline-start: auto;
  line-height: 0;
  max-width: var(--_er-width);
  min-width: var(--_er-width);
  aspect-ratio: var(--_er-aspect-ratio);

  &[locale$='_CH'] {
    --_er-aspect-ratio: 240 / 320;
  }

  &[locale='fr_FR'] {
    @include wb.breakpoint-from(mq4) {
      --_er-width: 85px;
    }
  }
}
</style>
